import { ADD_CART, SET_CART } from "services/redux/action-types";
import { cartConstants } from "services/redux/cart/constants";
import _ from 'lodash';
import HelperTime from "utils/helper-time";
import { dataConstants } from 'services/redux/data/constants'
import { constantsActive } from 'utils/constants/constants'
import { combineKindSubKind } from 'utils/timeslot-key'

const cartMiddleware = store => {
	return (
		next => {
			return (
				action => {
					switch( action.type ) {
						case ADD_CART:
							const firstKey = Object.keys( action.payload )[0];

							const actionPayload = _.get( action.payload, firstKey, {} );
							const payloadTimeslot = _.get( actionPayload, [ 'timeslot' ], null );
							const timeslotProperties = _.get( store.getState().data[ dataConstants.TIMESLOT_KINDS ], combineKindSubKind( payloadTimeslot ), null );

							if( timeslotProperties?.can_only_select_one_per_day === constantsActive.YES) {
								const timeslots = store.getState().cart[ cartConstants.TIMESLOTS ];

								// Lunch timeslots is only one per day
								// When the same day is selected, filter the previous same day selected out
								// And add the new one
								if ( !_.isEmpty( timeslots ) ) {
									const filteredTimeslots = _.pickBy( timeslots, ( o ) => {
										//If it is the same day, we need to do some checks
										if ( o.booking_date === actionPayload.booking_date && combineKindSubKind( o.timeslot ) === combineKindSubKind( payloadTimeslot ) ) {

											const doesOverlap = HelperTime.checkOverlap( HelperTime.createSegments( o, actionPayload ) );

											// If it overlaps, we remove the old one
											if ( doesOverlap ) {
												return false;
											}

											// Only one lunch timeslot per building per day
											// If the building is different
											if ( o?.building?.guid === actionPayload?.building?.guid ) {
												return false;
											}
										}

										return true;
									} );

									return next( {
										type: SET_CART,
										key: action.key,
										payload: {
											...filteredTimeslots, ...action.payload
										}
									});
								}
							}
					}
					return next( action );
				}
			);
		}
	);
};

export default cartMiddleware;
